import React from 'react';
import { Col, Row } from 'react-bootstrap';

import CampaignContent from 'components/CampaignContent/CampaignContent';
import getColSizeByCampaignContent from 'components/CampaignContent/getColSizeByCampaignContent';
import { ICampaignContent } from 'models/campaignContent';

interface IProps {
  campaignContents: ICampaignContent[];
  colour: string;
}

const CampaignContentsRow: React.FC<IProps> = ({
  campaignContents,
  colour,
}) => {
  return (
    <Row className="justify-content-center mb-n4 mb-lg-n5">
      {!!campaignContents?.length &&
        campaignContents.map((campaignContent: ICampaignContent) => (
          <Col
            key={campaignContent.id}
            {...getColSizeByCampaignContent(
              campaignContent.layout?.layout_type,
            )}
            className="mb-4 mb-lg-5 d-flex flex-column"
          >
            <CampaignContent
              campaignContent={campaignContent}
              colour={colour}
              layout={campaignContent.layout?.layout_type}
            />
          </Col>
        ))}
    </Row>
  );
};

export default CampaignContentsRow;
